// extracted by mini-css-extract-plugin
export default {"link":"UsersList_link__0rNyn"};